import { render, staticRenderFns } from "./specifications-details.vue?vue&type=template&id=3c73c0ed&scoped=true&"
import script from "./specifications-details.vue?vue&type=script&lang=js&"
export * from "./specifications-details.vue?vue&type=script&lang=js&"
import style0 from "./specifications-details.vue?vue&type=style&index=0&id=3c73c0ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c73c0ed",
  null
  
)

export default component.exports